import { render, staticRenderFns } from "./addTracksView.vue?vue&type=template&id=aede107c&scoped=true&"
import script from "./addTracksView.vue?vue&type=script&lang=js&"
export * from "./addTracksView.vue?vue&type=script&lang=js&"
import style0 from "./addTracksView.vue?vue&type=style&index=0&id=aede107c&prod&lang=scss&scoped=true&"
import style1 from "./addTracksView.vue?vue&type=style&index=1&id=aede107c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aede107c",
  null
  
)

export default component.exports